
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guaranteed-standards",
      function () {
        return require("private-next-pages/guaranteed-standards.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guaranteed-standards"])
      });
    }
  